import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

export const supportedLngs = {
  en: "EN",
  sv: "SV",
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator"],
      caches: ["localStorage", "cookie"],
    },
    fallbackLng: "en",
    supportedLngs: Object.keys(supportedLngs),
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          hello_world: "Hello, World!",
          sign: "Sign",
          sign_the_open_letter: "Sign the open letter",
          signatures: " signatures",
          stockholm_cultural_workers_for_palestine:
            "Stockholm Cultural Workers for Palestine",
        },
      },
      sv: {
        translation: {
          hello_world: "Hallå, världen!",
          sign: "Skriv under",
          sign_the_open_letter: "Skriv under det öppna brevet",
          signatures: " signaturer",
          stockholm_cultural_workers_for_palestine:
            "Stockholms kulturarbetare för Palestina",
        },
      },
    },
  });

export default i18n;
